import { PTO_URL } from '@/api/pto/const'
import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'
import { createBaseCRUDApi } from '@/api/base'

export const PTO_HANDBOOK_STATEMENT_TYPE_URL = `${PTO_URL}/statement-type`

const errors = createBaseResponseErrors('тип деф. ведомости', 'типов деф. ведомости')

export const PTOHandbookStatementTypeApi = createBaseCRUDApi(PTO_HANDBOOK_STATEMENT_TYPE_URL, errors)
